import PhotoUploader from '../PhotoUploader/PhotoUploader';

import GenericForm from '../../lib/GenericForm';
import ReviewCritic from './ReviewCritic';
import {initStarWidgets} from './StarWidgetGroup';
import LocalUrlMaker from "../../lib/LocalUrlMaker";

export default class CreateReviewForm extends GenericForm {
  constructor($form) {
    super($form);
    this.url = LocalUrlMaker.prefixedPath("/reviews.json");

    this.photo_uploader = new PhotoUploader($('#new_customer_photo'));
    this.critic = new ReviewCritic($("#product_review_body"));
    // this.stars = new StarWidgetGroup();

    initStarWidgets();

    $('#submit-button').click(() => this.onSubmit());

    console.log("initialized createReviewForm");

    window.createReviewForm = this;
  }

  errors() {
    let fields = this.formContents();
    let errs = {};

    let required = ['overall_rating', 'performance_rating', 'quality_rating', 'appearance_rating', 'install_time'];
    for (let f of required) {
      let v = fields["product_review[" + f + "]"];
      if (!v) {
        if (f === 'install_time') {
          errs['install_time'] = "Don't forget to tell us how long it took to install.";
        } else {
          errs['stars'] = "Be sure to select a star for each of the four rating criteria.";
        }
      }
    }

    if (!this.critic.reviewValid()) {
      errs.body = "Please write a longer review.";
    }

    return errs;
  }

  onSubmit() {
    console.log("CreateReviewForm.onSubmit() called");

    if (this.displayErrors()) {
      return false;
    }

    console.log(`CreateReviewForm.onSubmit: posting to ${this.url}...`);

    return this.post();
  }

  // after a successful submission, display the #after-review part,
  // which is found in views/product_reviews/_after_review.html.haml
  onSuccess(response, status, xhr) {
    console.log("CreateReviewForm.onSuccess: " + JSON.stringify(response, null, 2));
    window.REVIEW_RESPONSE = response;

    let review = response.product_review;

    if (review && review.id) {
      // CSS hides #after-review until this class is added to main
      $('main').addClass('review-complete');

      window.location.hash = 'review-complete';

      const e = document.getElementById('after-review');
      e.classList.remove('hidden');

      //
      // e.classList.remove('max-h-0', 'opacity-0');
      // e.classList.add('max-h-200', 'opacity-100');

      e.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });

      // requestAnimationFrame(() => {
      //   //e.style.height = `${e.scrollHeight}px`;
      //
      //
      // });

      //
      // let $after = $('#after-review');
      // let o = $after.offset();
      // let y = o ? o.top - 40 : 200;
      //
      // $after.show(200, function () {
      //   $('html, body').animate({scrollTop: y}, 500);
      //
      //   window.location.hash = 'review-complete';
      // });
    } else {
      // craptastic fallback
      alert("Your review has been submitted. Thank you!");
    }
  }

}

